<template>
  <router-view/>
</template>

<style>
/* main css file */
@import 'assets/css/app.css';
</style>
